module.exports = __webpack_public_path__ + "img/operationIncome.1fb844f4.svg";